import type { UseInvalidateOptions } from "./validation.type";

import get from "lodash/get";

import { client } from "@/config/client";
import { useModelMutation } from "@/hooks/queries";

export const useInvalidateModel = (
  model: "observations",
  id: number,
  options?: UseInvalidateOptions
) => {
  return useModelMutation(model, id, {
    ...(options ?? {}),
    mutationFn: () => get(client, [model, "invalidate"])(id),
  });
};
